<template>
  <div class="modal-log">
    <div class="modal-content">
      <div class="modal-title">{{ $t('main.versionLog') }}</div>
      <div class="modal-version">V{{ versionLog.version }}</div>
      <div class="modal-desc">
        <div
          class="desc-item"
          v-for="(desc, index) in versionLog.desc"
          :key="index"
        >
          {{ desc }}
        </div>
        <div class="version-time">{{ versionLog.time }}</div>
      </div>
      <div class="modal-btn" @click="close">{{ $t('main.confirm') }}</div>
      <img
        class="close"
        src="../../assets/close-modal.png"
        @click="$emit('closeModal')"
      />
    </div>
  </div>
</template>

<script>
import { TP_SERVER_DOMAIN } from "../../utils";
import dayjs from 'dayjs';
export default {
  props: {
    modalTextData: {
      type: Object,
    },
    logParam: {
      type: Object,
    },
  },
  data() {
    return {
      versionLog: {
        version: '',
        desc: [],
        time: undefined,
      },
      platform: 1,
    };
  },
  created() {
    this.getVersionLog(this.logParam);
  },

  methods: {
    close() {
      this.$emit('closeModal');
    },
    async getVersionLog(obj) {
      const { platform, version, channel } = obj;
      this.versionLog.version = version;
      this.platform = platform;
      let lang = this.$i18n.locale;
      if (lang === 'zh') {
        lang = 'zh-Hans';
      } else if (lang === 'zh-tw') {
        lang = 'zh-Hant';
      } else {
        lang = 'en';
      }
      try {
        const response = await fetch(
          `${TP_SERVER_DOMAIN}/v1/version/upgrade?platform=${platform}&version=${version}&channel=${channel}&lang=${lang}`
        );
        const res = await response.json();
        if (res.result === 0 && res.data) {
          console.log('versionLog', res.data);
          this.versionLog.desc = JSON.parse(res.data.desc);
          this.versionLog.time = dayjs(res.data.timestamp * 1000).format('YYYY-MM-DD');
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-log {
  position: fixed;
  z-index: 10000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background: rgba(20, 20, 22, 0.9);
  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 448px;
    border-radius: 20px;
    box-shadow: 0px 64px 64px -48px rgba(31, 47, 70, 0.12);
    padding: 32px;
    width: 448px;
    background: #fcfcfd;
    display: flex;
    flex-direction: column;
    align-items: center;
    .modal-title {
      font-size: 26px;
      font-weight: 700;
      text-align: center;
      color: #23262f;
      letter-spacing: -0.03px;
    }
    .modal-version {
      margin-top: 12px;
      width: fit-content;
      padding: 4px 32px;
      background: #ebf4ff;
      border-radius: 48px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      color: #2980fe;
    }
    .modal-desc {
      position: relative;
      margin-top: 12px;
      width: 100%;
      height: 332px;
      padding: 16px;
      background: #f2f2f2;
      border-radius: 11px;
      font-size: 14px;
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .desc-item {
        line-height: 24px;
      }
      .version-time {
        position: absolute;
        right: 16px;
        bottom: 16px;
      }
    }
    .modal-btn {
      width: 100%;
      margin-top: 32px;
      background: #2980fe;
      border-radius: 90px;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      color: #fcfcfd;
      padding: 16px 0;
      cursor: pointer;
    }
    .close {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 767px) {
  .modal-log {
    .modal-content {
      width: 80%;
      border-radius: 12px;
      padding: 16px 20px;
      .modal-title {
        font-size: 18px;
      }
      .modal-version {
        margin-top: 10px;
        font-size: 13px;
        font-weight: 600;
      }
      .modal-desc {
        margin-top: 10px;
        height: 288px;
        font-size: 12px;
        font-weight: 400;
        padding: 8px 12px;
        .version-time {
          right: 12px;
          bottom: 8px;
        }
      }
      .modal-btn {
        margin-top: 24px;
        font-size: 12px;
        padding: 13px 0;
      }
      .close {
        width: 14px;
        height: 14px;
        top: 20px;
        right: 20px;
      }
    }
  }
}
</style>
